export default window.careHelpfulFunctions;